import { Navigate, Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth-store';

interface RedirectState {
  from?: { pathname?: string };
}

/** Public landing page and the homepage submitted to Google OAuth. */
export function HomePage() {
  const status = useAuthStore((state) => state.status);
  const location = useLocation();
  const redirectState = location.state as RedirectState | null;

  if (status === 'authenticated') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <main className="home-page">
      <section className="home-page__hero" aria-labelledby="home-title">
        <p className="home-page__eyebrow">LiveForge</p>
        <h1 id="home-title">The self-hosted studio for live productions.</h1>
        <p className="home-page__summary">
          Produce multi-camera broadcasts with remote guests, composited graphics, recordings,
          and YouTube output from one browser-based control room.
        </p>
        <div className="home-page__actions">
          <Link className="button button--primary" to="/login" state={redirectState}>
            Sign in to LiveForge
          </Link>
          <Link className="button button--secondary" to="/privacy">
            Privacy Policy
          </Link>
        </div>
      </section>

      <section className="home-page__features" aria-label="LiveForge features">
        <article>
          <h2>Direct the programme</h2>
          <p>Build scenes, stage a preview, and take the programme live from a vision-mixer UI.</p>
        </article>
        <article>
          <h2>Bring people together</h2>
          <p>Invite remote guests into the studio with audio and video handled in the browser.</p>
        </article>
        <article>
          <h2>Own the output</h2>
          <p>Run it on your infrastructure, record the programme, and connect your YouTube channel.</p>
        </article>
      </section>

      <footer className="home-page__footer">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
      </footer>
    </main>
  );
}
